import { z } from 'zod';

/**
 * 견적 금액·수량의 원시 정의 — `quotes.ts` 와 `shipping.ts` 가 함께 쓰는 잎(leaf) 모듈이다. `quotes.ts` 가 `shipping.ts` 를
 * import 하므로(배송지 입력) 두 파일이 서로를 import 하지 않도록 여기 둔다. 공개 이름은 `quotes.ts` 재노출로만 내보낸다.
 */
/** PostgreSQL int4에 저장하는 원 단위 정수와 수량. 소수 Decimal을 반올림하지 않는다. */
export const QUOTE_INT_MIN = -2147483648;
export const QUOTE_INT_MAX = 2147483647;
export const quoteIntegerSchema = z.number().int().min(QUOTE_INT_MIN).max(QUOTE_INT_MAX);
export const quoteQuantitySchema = quoteIntegerSchema.min(1);

const VAT_INCLUSIVE_DIVISOR = 1.1;
/**
 * 부가세 포함 합계 → 공급가액(합계 ÷ 1.1, 원 단위 반올림)·부가세(차액) (견적 설계 §6-3). api 도메인 계산·web 임시 견적·
 * admin 초안 미리 계산이 모두 이 함수를 쓴다 — 규칙이 한곳에만 있다.
 */
export const splitVatInclusiveTotal = (
  totalAmount: number,
): { readonly supplyAmount: number; readonly vatAmount: number } => {
  const supplyAmount = Math.round(totalAmount / VAT_INCLUSIVE_DIVISOR);
  return { supplyAmount, vatAmount: totalAmount - supplyAmount };
};
